import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditUserComponent } from "./edit-user/edit-user.component";

@Component({
  selector: "app-user-v11",
  templateUrl: "./user-v11.component.html",
  styleUrls: ["./user-v11.component.scss"],
})
export class UserV11Component extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }
  openPanel() {
    this.customanpanel = EditUserComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
